import styled, { css } from "styled-components";
import { Button as ButtonPrimitive } from "@sonder/ui/source/styled/primitives/Button";
import { backgroundHighlights, colors } from "@sonder/ui/source/styled/theme";

export type BackgroundVariant = "light" | "medium" | "dark";
export interface VariantProps {
  backgroundVariant: BackgroundVariant;
}
interface GetVariantInput {
  light?: string;
  medium?: string;
  dark?: string;
}
const getVariant = (options: GetVariantInput) => (props: VariantProps) => {
  const backgroundVariant = props.backgroundVariant || "dark";
  return options[backgroundVariant];
};

export const BaseButtonStyle = css`
  align-items: center;
  color: ${getVariant({
    light: colors.gray4,
    dark: colors.grayF,
    medium: colors.grayF,
  })};
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  position: relative;
  z-index: 0;

  > svg {
    font-size: 1.5rem;
  }
  &:after {
    background: rgba(0, 0, 0, 0);
    border-radius: 100%;
    content: "";
    height: 100%;
    position: absolute;
    width: 100%;
    z-index: -1;
  }
  &:disabled {
    opacity: 0.4;
  }
  &:focus:not(:disabled):after,
  &:hover:not(:disabled):after {
    background: ${getVariant(backgroundHighlights.hover)};
  }
  &:active:not(:disabled):after {
    background: ${getVariant(backgroundHighlights.active)};
  }
`;

export interface CircleButtonProps extends VariantProps {
  selected?: boolean;
}
export const CircleButton = styled(ButtonPrimitive)<CircleButtonProps>`
  ${BaseButtonStyle}
  color: ${props =>
    props.selected &&
    getVariant({
      light: colors.blue7,
      dark: colors.white,
      medium: colors.white,
    })};
  font-size: 1.75rem;
  height: 2.3rem;
  width: 2.3rem;
`;
